import * as React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Copyright from '../internals/components/Copyright';
import StatCard from './StatCard';
import ActorStatCard from './ActorStatCard';
import axios from "axios";
import {useEffect, useState} from "react";
import { useGrowSetup } from '../GrowSetupContext';
import { AuthContext } from "./signin/AuthContext";
import { useContext } from "react";
import MainGrid from "./MainGrid";
import MainGrid_Curator from "./MainGrid_Curator";


export default function MainGrid_Wrapper(props) {

    const { grow_setup, setGrowSetup, device_type, setDeviceType } = useGrowSetup();
    const { token } = useContext(AuthContext);
    
    




  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      {device_type === 1 && <MainGrid />}
      {device_type === 3 && <MainGrid_Curator />}
    </Box>
  );
}
